import { API_BASE_URL } from './formatters';

export function generateCodeSnippet(language, keyId, endpoint, fullKeys) {
  const fullKey = fullKeys.get(keyId);
  const apiKey = fullKey || 'YOUR_API_KEY';

  switch (language) {
    case 'curl':
      return `curl -X POST "${API_BASE_URL}${endpoint}" \\
  -H "Authorization: Bearer ${apiKey}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "messages": [
      {"role": "user", "content": "Hello!"}
    ]
  }'`;
    case 'python':
      return `import requests

url = "${API_BASE_URL}${endpoint}"
headers = {
    "Authorization": "Bearer ${apiKey}",
    "Content-Type": "application/json"
}
data = {
    "messages": [
        {"role": "user", "content": "Hello!"}
    ]
}

response = requests.post(url, json=data, headers=headers)
print(response.json())`;
    case 'javascript':
      return `const response = await fetch("${API_BASE_URL}${endpoint}", {
  method: "POST",
  headers: {
    "Authorization": "Bearer ${apiKey}",
    "Content-Type": "application/json"
  },
  body: JSON.stringify({
    messages: [
      { role: "user", content: "Hello!" }
    ]
  })
});

const data = await response.json();
console.log(data);`;
    default:
      return '';
  }
}
